<template>
  <div class="text-left">
    <div :class="getInlineStyle">
      <label
        v-if="label"
        :for="target"
        :class="[labelClasses, getLabelClasses]"
        @click="onLabelClick"
        class="block text-sm select-none leading-tight pb-2"
      >
        <slot name="label">{{ label }}</slot>
      </label>
      <div class="relative flex-1">
        <p
          v-if="required"
          :class="{ 'pb-2': !underlined }"
          class="absolute top-0 right-0 transform -translate-y-full text-sm select-none leading-tight text-gray-500"
        >
          Requis
        </p>
        <slot />
        <form-layer
          :icon="icon"
          :icon-classes="iconClasses"
          :focused="focused"
          :class="{ 'is-underlined': underlined, 'items-start': position === 'start' }"
        >
          <template #icon>
            <slot name="icon" />
          </template>
          <template #action>
            <slot name="action" />
          </template>
        </form-layer>
      </div>
    </div>
    <form-error :inline="inline" :error="error" />
    <slot name="ending" />
  </div>
</template>

<script>
import FormLayer from './FormLayer'
import FormError from './FormError'

export default {
  components: {
    FormLayer,
    FormError
  },
  props: {
    target: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    labelClasses: {
      type: [String, Array],
      default: null
    },
    iconClasses: {
      type: [String, Array],
      default: null
    },
    error: {
      type: [String, Array],
      default: null
    },
    position: {
      type: String,
      default: 'center'
    },
    underlined: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLabelClasses () {
      return {
        // 'pb-2': !this.underlined && !this.inline,
        'w-100px flex-shrink-0 pr-2 md:pb-0': this.inline
      }
    },
    getInlineStyle () {
      return {
        'md:flex': this.inline,
        'md:items-start': this.position === 'start' && this.inline,
        'md:items-center': this.position === 'center' && this.inline
      }
    }
  },
  methods: {
    onLabelClick (event) {
      if (this.$listeners['label-click']) {
        event.preventDefault()
        this.$emit('label-click')
      }
    }
  }
}
</script>

<style scoped>
</style>
